var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BasePaymentForm", {
    attrs: { showSecured: true },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "form-group mb-1" },
              [
                _c("BaseCreditCardForm", {
                  attrs: {
                    form: _vm.form,
                    validate: _vm.validate,
                    state: _vm.paymentMethod,
                    isSubmitted: _vm.isSubmitted,
                    inputClassName: "form-control-sm"
                  },
                  on: {
                    "update:form": function($event) {
                      _vm.form = $event
                    },
                    "update:validate": function($event) {
                      _vm.validate = $event
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group mb-1" },
              [
                _c("SectionHeader", {
                  attrs: { title: _vm.$t("apps.payment.message.item") }
                }),
                _vm._v(" "),
                _c("Table", { attrs: { invoice: _vm.invoice } })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer-text",
        fn: function() {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("apps.payment.message.amounttotal")) +
                ":\n    " +
                _vm._s(
                  _vm.getCurrencyWithNumber(
                    _vm.numberel(_vm.invoice.total, "0,0.00")
                  )
                ) +
                "\n  "
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer-actions",
        fn: function() {
          return [
            _c("BaseButton", {
              attrs: {
                text: _vm.$t("button.prev"),
                className: "btn-secondary mr-2",
                disabled: _vm.isSubmitted
              },
              on: { click: _vm.onClickPrev }
            }),
            _vm._v(" "),
            _c(
              "BaseButton",
              {
                attrs: {
                  className: "btn-web",
                  disabled: _vm.isSubmitted || _vm.nextBtnDisabled
                },
                on: { click: _vm.onClickNext }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("apps.billing.button.payamount", {
                        number: _vm.getCurrencyWithNumber(
                          _vm.numberel(_vm.invoice.total, "0,0.00")
                        )
                      })
                    ) +
                    "\n      "
                ),
                _vm.isSubmitted
                  ? _c("i", { staticClass: "fas fa-spinner spin" })
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20b53a2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20b53a2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/InvoiceConfirm.vue
// module id = null
// module chunks = 